import React from 'react';
import { SignIn as ClerkSignIn } from '@clerk/clerk-react';
import styled from 'styled-components';


const SignInContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: ${({ theme }) => theme.bg};
`;

const SignInCard = styled.div`
  background: ${({ theme }) => theme.card};
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid ${({ theme }) => theme.soft};
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.text_primary};
  font-size: 2rem;
  font-weight: 1000;
`;

const SignIn = () => {
  return (
    
    <SignInContainer>
      <SignInCard>
        <Title>Welcome Back</Title>
        <ClerkSignIn 
          appearance={{
            elements: {
              rootBox: {
                width: '1000%',
              },
              card: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                border: 'none',
              },
              headerTitle: {
                color: '#ffffff',
                fontSize: '1.5rem',
              },
              headerSubtitle: {
                color: '#a0a0a0',
              },
              socialButtonsBlockButton: {
                backgroundColor: '#2a2a2a',
                border: '1px solid #404040',
                height: '40px',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#3a3a3a',
                },
              },
              formFieldInput: {
                backgroundColor: '#ffffff',
                border: '1px solid #404040',
                height: '40px',
                color: '#404040',
                '&:focus': {
                  borderColor: '#6366f1',
                },
              },
              formButtonPrimary: {
                height: '50px',
                backgroundColor: '#007AFF',
                '&:hover': {
                  backgroundColor: '#007AFF',
                },
              },
              footerActionLink: {
                color: '#6366f1',
              },
              identityPreviewText: {
                color: '#ffffff',
              },
              identityPreviewEditButton: {
                color: '#6366f1',
              },
              footer: {
                display: 'none', // Hide the "Secured by Clerk" footer
              },
              footerText: {
                display: 'none',
              },
              footerAction: {
                display: 'none',
              },
            },
          }}
        />
      </SignInCard>
    </SignInContainer>
  );
};

export default SignIn;
